import AuctionItemDetailsCard from './AuctionItemDetailsCard';

export default AuctionItemDetailsCard;
